import initVueApp from "@/core.js";
const component = require(`./../views/Returns.vue`).default;
initVueApp(component);
